import React, { FunctionComponent } from 'react';

import { connect } from 'react-redux';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import AppState from '@webapp/store/state';

//Components
import Box from '@components/layout/box';
import Tag from '@components/basics/tag';
import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';
import { AnimatePresence } from 'framer-motion';
import { ExternalAccount } from '@services/stripe-connect/types/external-account';

interface AccountItemProps {
  className?: string;
  account: ExternalAccount;
  isMobile: boolean;
}

const mapStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

const AccountItem: FunctionComponent<AccountItemProps> = ({
  className,
  account,
  isMobile,
}) => {
  return (
    <Box className={className || ''}>
      <Flex
        className="first-line"
        justifyContent="space-between"
        alignItems="center"
      >
        <div className="left-info">
          <Typography weight="700">{account.name}</Typography>
          {!isMobile && (
            <Typography type="small" className="address-text">
              {account.country} - {account.currency}
            </Typography>
          )}
        </div>
        <Flex justifyContent="flex-end" alignItems="center" gap={10}>
          <AnimatePresence exitBeforeEnter>
            {account.main ? (
              <MotionOpacity>
                <Tag>
                  <Translate id="USER_PROFILE.WALLET.ACCOUNTS.ITEM.PRIMARY" />
                </Tag>
              </MotionOpacity>
            ) : null}
          </AnimatePresence>
        </Flex>
      </Flex>
      <Flex justifyContent="space-between" alignItems="center">
        <Typography className="secondary-text" type="small">
          {account.last4}
        </Typography>
        <Typography
          className="secondary-text"
          type="small"
          align="right"
          capitalize
        >
          {account.currency}
        </Typography>
      </Flex>
    </Box>
  );
};

export default connect(mapStateToProps)(styled(AccountItem)`
  background-color: ${({ theme }) => theme.colors.differentBackground};

  .first-line {
    margin-bottom: 10px;
    gap: 24px;
    @media ${({ theme }) => theme.device.tablet} {
      margin-bottom: 40px;
    }

    .left-info {
      flex-grow: 0;
    }
  }

  .address-text {
    margin-bottom: 20px;
    word-break: break-word;
    color: ${({ theme }) => theme.colors.tertiary};
    @media ${({ theme }) => theme.device.tablet} {
      margin-top: 5px;
      margin-bottom: 0;
    }
  }

  .menu {
    .open-icon,
    .close-icon {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }

  .secondary-text {
    color: ${({ theme }) => theme.colors.tertiary};
  }
`);
